import React from 'react';
import AdminPanelDiagnosisCodesForm from 'components/molecules/admin-panel/forms/diagnosis-codes';
import AdminPanelEmrDetailsForm from 'components/molecules/admin-panel/forms/emr-details';
import BaseGrid from 'components/atoms/base-grid';
import PriorAuthorizationForm from 'components/molecules/admin-panel/forms/prior-authorization';
import PatientSubscriptionsForm from 'components/molecules/admin-panel/forms/patient-subscriptions';
import { ModuleType } from 'infrastructure/enums';
import CareLocationTable from 'components/molecules/admin-panel/forms/care-location/table';
import Attachments from 'components/organisms/patient-attachments';
import { isCcmModule, isCombinedModule } from 'infrastructure/functions';
import { useCheckPatientModule } from 'infrastructure/hooks/patient/use-check-patient-module';

import s from './styles.module.scss';

interface IAdminTabbedFormOtherInfoProps {
  patientGuid: string;
  module: ModuleType;
  readOnly: boolean;
}

const AdminTabbedFormOtherInfo: React.FC<IAdminTabbedFormOtherInfoProps> = (
  props,
) => {
  const { patientGuid, module, readOnly } = props;
  const { isBlockCcmModule, isReadonlyCcmModule } =
    useCheckPatientModule(patientGuid);
  const readOnlyCareLocation = isCombinedModule(module)
    ? isBlockCcmModule || isReadonlyCcmModule || readOnly
    : readOnly;

  return (
    <BaseGrid rowGap={20} className={s.wrapper}>
      <BaseGrid columns={2} columnGap={20} className={s['columns-grid']}>
        <div className={s.column}>
          <AdminPanelDiagnosisCodesForm
            patientGuid={patientGuid}
            module={module}
            readOnly={readOnly}
          />
        </div>
        <div className={s.column}>
          <AdminPanelEmrDetailsForm
            patientGuid={patientGuid}
            module={module}
            readOnly={readOnly}
          />
        </div>
      </BaseGrid>
      {!isCcmModule(module) && (
        <div className={s.column}>
          <PriorAuthorizationForm patientGuid={patientGuid} module={module} />
        </div>
      )}
      {(isCcmModule(module) || isCombinedModule(module)) && (
        <div className={s.column}>
          <CareLocationTable
            patientGuid={patientGuid}
            readOnly={readOnlyCareLocation}
          />
        </div>
      )}
      <div className={s.column}>
        <PatientSubscriptionsForm
          patientGuid={patientGuid}
          module={module}
          readOnly={readOnly}
        />
      </div>
      {module === ModuleType.ADMIN && (
        <div className={s.column}>
          <Attachments patientGuid={patientGuid} readOnly={readOnly} />
        </div>
      )}
    </BaseGrid>
  );
};

export default AdminTabbedFormOtherInfo;
